import { css } from 'styled-components';
import colors from '../helpers/colors';
import fonts from '../helpers/fonts';
import mediaQuery from '../helpers/mediaQuery';
import spacing from '../helpers/spacing';
import { buttonResetStyleIncludingFocus } from './buttonReset';
import { twoLayeredBoxShadow } from './styling';

export const outerSectionStyling = css`
  padding: ${spacing(2)} 0;
  width: 100%;
  border-bottom: 2px solid ${colors.neutral06};

  ${mediaQuery.tabletPortrait`
    padding: ${spacing(3)} 0;
  `}
`;

export const sectionButtonStyling = css`
  ${buttonResetStyleIncludingFocus};

  /* We add spacing(2) to compensate for the extra margin on each side. */
  width: calc(100% + ${spacing(2)});
  margin: ${spacing(-1)};
  padding: ${spacing(1)};
  display: flex;
  justify-content: space-between;
  text-align: left;
  text-decoration: none;

  :hover,
  :focus-visible {
    background-color: ${colors.neutral06};
    border-radius: 0px;
  }

  :focus-visible {
    box-shadow: ${twoLayeredBoxShadow(colors.neutral08, colors.core02)};
  }
`;

export const sectionTitleStyling = css`
  ${fonts.headingMedium};
  margin: 0;
`;

export const iconStyling = css`
  margin: auto 0 auto ${spacing(2)};
  flex-shrink: 0;
`;
